import { useEffect, useState } from 'react';
import './toggle-button.css';

export interface ToggleButtonProps {
  onActivate?(): any;

  onDeactivate?(): any;

  activatedLabel?: string;
  deactivatedLabel?: string;
  renderLabelOn?: 'left' | 'right';
  isActivated?: boolean;
  isDisabled?: boolean;
  isLoading?: boolean;
  updateInstantly?: boolean;
}

export const ToggleButton = ({
  activatedLabel = '',
  deactivatedLabel = '',
  isActivated = false,
  isDisabled = false,
  isLoading,
  onActivate = () => {},
  onDeactivate = () => {},
  renderLabelOn,
  updateInstantly,
}: ToggleButtonProps) => {
  const [toggleState, setToggleState] = useState(isActivated);

  useEffect(() => {
    if (!updateInstantly && isActivated !== undefined) {
      setToggleState(isActivated);
    }
  }, [isActivated]);

  const onClick = (e) => {
    e.preventDefault();

    if (isDisabled) {
      return;
    }

    e.stopPropagation();

    const updatedToggleState = !toggleState;
    updatedToggleState && onActivate();
    !updatedToggleState && onDeactivate();
    updateInstantly && setToggleState(updatedToggleState);
  };

  const renderLabel = () => (
    <span
      className={`
        ${renderLabelOn === 'left' ? 'pr-2' : 'pl-2'}
        ${isDisabled ? 'opacity-60 text-grey-30' : 'text-black dark:text-white'}
        text-sm
        font-bold
        select-none
      `}
    >
      {toggleState ? activatedLabel : deactivatedLabel}
    </span>
  );

  return (
    <div className={`flex items-center`}>
      {renderLabelOn === 'left' && renderLabel()}
      <div
        className={`
          ${
            isDisabled
              ? 'bg-grey-10 opacity-60 dark:bg-grey-30 cursor-not-allowed '
              : toggleState
              ? 'bg-lime hover:bg-lime-dark-1 cursor-pointer'
              : `
                bg-grey-10
                hover:bg-grey-30
                cursor-pointer
                dark:bg-grey-30
                dark:hover:bg-grey-50
              `
          }
          relative
          flex
          w-10
          h-5
          items-center
          rounded-full
        `}
        onClick={onClick}
      >
        <div
          className={`
            flex
            w-3.5
            h-3.5
            rounded-full
            shadow-strong
            bg-white
            ${toggleState ? 'ml-auto mr-1' : 'mr-auto ml-1'}
          `}
        />
        {isLoading && (
          <div
            className={`
              absolute
              flex
              justify-center
              items-center
              w-full
              h-full
              rounded-full
              bg-grey-backdrop
            `}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              height="16"
              width="16"
              className="fill-current"
            >
              <g className="nc-icon-wrapper" stroke="none">
                <g className="nc-loop-dots-4-16-icon-f">
                  <circle cx="3" cy="8" r="2"></circle>
                  <circle cx="8" cy="8" r="2" data-color="color-2"></circle>
                  <circle cx="13" cy="8" r="2"></circle>
                </g>
              </g>
            </svg>
          </div>
        )}
      </div>
      {renderLabelOn === 'right' && renderLabel()}
    </div>
  );
};
